export default {
  computed: {
    steps() {
      const steps = [];

      steps.push({ name: 'unbarring.access' });

      if (!this.isAuthorized) {
        steps.push({ name: 'unbarring.confirmation' });
      }

      if (this.hasPin) {
        steps.push({ name: 'unbarring.pin' });
      }

      return steps;
    },
  },
};
